var map = {
	"./game-1.png": 7084,
	"./game-10.png": 9601,
	"./game-11.png": 7139,
	"./game-12.png": 6233,
	"./game-13.png": 2875,
	"./game-14.png": 6266,
	"./game-15.png": 147,
	"./game-16.png": 7558,
	"./game-17.png": 2116,
	"./game-18.png": 8839,
	"./game-2.png": 6773,
	"./game-3.png": 7953,
	"./game-4.png": 8573,
	"./game-5.png": 7815,
	"./game-6.png": 1351,
	"./game-7.png": 1273,
	"./game-8.png": 2290,
	"./game-9.png": 399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1357;